import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileMenuService {
  private mobileMenuOpenSubject = new BehaviorSubject<boolean>(false);
  public mobileMenuOpen$ = this.mobileMenuOpenSubject.asObservable();

  toggleMobileMenu(): void {
    this.mobileMenuOpenSubject.next(!this.mobileMenuOpenSubject.value);
  }

  closeMobileMenu(): void {
    this.mobileMenuOpenSubject.next(false);
  }

  openMobileMenu(): void {
    this.mobileMenuOpenSubject.next(true);
  }

  get isMobileMenuOpen(): boolean {
    return this.mobileMenuOpenSubject.value;
  }
}
